"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const assets_1 = require("~/assets");
const ErrorModals_1 = require("~/components/ErrorModals");
const UI_1 = require("~/components/UI");
const accountTabs_1 = require("~/consts/accountTabs");
const routes_1 = require("~/consts/routes");
const useCurrentAccountTabId_1 = __importDefault(require("~/hooks/useCurrentAccountTabId"));
const useInfiniteFetch_1 = __importDefault(require("~/hooks/useInfiniteFetch"));
const useIntersectionObserver_1 = __importDefault(require("~/hooks/useIntersectionObserver"));
const consts_1 = require("~/store/account/consts");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const react_helmet_async_1 = require("react-helmet-async");
const TeamMemberList_1 = __importDefault(require("./TeamMemberList"));
const TeamModal_module_scss_1 = __importDefault(require("./TeamModal.module.scss"));
function TeamModal() {
    (0, useCurrentAccountTabId_1.default)(accountTabs_1.TAB_IDS.TEAM);
    const loader = (0, react_1.useRef)(null);
    const currentTeamRoleUser = (0, react_redux_1.useSelector)(selectors_1.selectTeamRole);
    const userType = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserRole);
    const currentUserDistributorId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUserDistributorId);
    const [forceRefresh, setForceRefresh] = (0, react_1.useState)(false);
    const [query, setQuery] = (0, react_1.useState)('');
    const [field, setField] = (0, react_1.useState)('firstName');
    const [sort, setSort] = (0, react_1.useState)('ASC');
    const [page, setPage] = (0, react_1.useState)(0);
    const [filterActive, setFilterActive] = (0, react_1.useState)(false);
    const [ownerMode, setOwnerMode] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => setPage(0), [field, sort]);
    const { dispatchDeleteUser } = (0, redux_1.bindActionCreators)({
        dispatchDeleteUser: actions_1.deleteUser,
    }, (0, react_redux_1.useDispatch)());
    const intersectionObserver = (0, useIntersectionObserver_1.default)(loader);
    const { result, setResult } = (0, useInfiniteFetch_1.default)({ query, page, field, sort, forceRefresh });
    const options = [
        { firstName: 'First Name' },
        { lastName: 'Last Name' },
        { email: 'Email' },
        { roleId: 'Role' },
    ];
    const onKeyDownHandler = (event) => {
        if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
            setFilterActive(!filterActive);
        }
    };
    (0, react_1.useEffect)(() => {
        if (intersectionObserver) {
            setPage((prev) => prev + 1);
        }
    }, [intersectionObserver]);
    (0, react_1.useEffect)(() => {
        if (currentUserDistributorId) {
            setQuery(`${process.env.API_HOSTNAME}/api/users/distributor/${currentUserDistributorId}/team`);
        }
    }, [currentUserDistributorId]);
    (0, react_1.useEffect)(() => {
        if (result && page === 0) {
            setForceRefresh(false);
        }
    }, [result]);
    (0, react_1.useEffect)(() => {
        setPage(0);
    }, [currentTeamRoleUser]);
    const deleteHandler = (id) => {
        dispatchDeleteUser(id);
        const usersList = result === null || result === void 0 ? void 0 : result.filter(function (item) {
            return item.id !== id;
        });
        setResult(usersList || null);
    };
    const mainContent = result ? (react_1.default.createElement("div", { className: TeamModal_module_scss_1.default.userList }, result && (react_1.default.createElement(TeamMemberList_1.default, { ownerMode: ownerMode, deleteHandler: deleteHandler, teamMembers: result, loader: react_1.default.createElement("div", { ref: loader }) })))) : undefined;
    const filterStateHandler = (state) => setFilterActive(state);
    (0, react_1.useEffect)(() => {
        setOwnerMode(currentTeamRoleUser === 1);
    }, [currentTeamRoleUser]);
    const teamModalHeadline = (react_1.default.createElement("div", { className: TeamModal_module_scss_1.default.headline },
        react_1.default.createElement(react_helmet_async_1.Helmet, null,
            react_1.default.createElement("title", null, "My Team | TBUILD")),
        react_1.default.createElement("span", null, "Team"),
        react_1.default.createElement("div", { className: TeamModal_module_scss_1.default.controls },
            ownerMode ? (react_1.default.createElement("div", { className: TeamModal_module_scss_1.default.addNew, onClick: () => navigate(routes_1.INVITE_TEAM_MEMBER), onKeyDown: (event) => {
                    if (event.key === 'Enter' || event.key === 'Accept' || event.key === ' ') {
                        navigate(routes_1.INVITE_TEAM_MEMBER);
                    }
                }, role: "button", tabIndex: 0 },
                react_1.default.createElement("img", { src: assets_1.svgBasicAddNew, alt: "" }),
                " ",
                react_1.default.createElement("span", null, "Invite"))) : null,
            react_1.default.createElement(UI_1.ElementDropdown, { hideOnSelect: false, element: react_1.default.createElement("div", null,
                    react_1.default.createElement("img", { src: assets_1.svgBasicSorting, "data-active": filterActive, onClick: () => setFilterActive(!filterActive), onKeyDown: onKeyDownHandler, alt: "" })), placement: "bottom-end", dropdown: react_1.default.createElement(UI_1.SortingDropdown, { options: options, field: field, order: sort, setField: (value) => setField(value), setOrder: (value) => setSort(value) }), activeStateHandler: filterStateHandler }))));
    if (userType === consts_1.UserRoles.customer) {
        return react_1.default.createElement(ErrorModals_1.ForbiddenModal, null);
    }
    return react_1.default.createElement(UI_1.ContentListModal, { headlineContent: teamModalHeadline, mainContent: mainContent });
}
exports.default = TeamModal;
